// extracted by mini-css-extract-plugin
export default {"tabsContainer":"CandidatePortalDashboard_tabsContainer__rhFIJ"};